import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Student } from 'src/app/model/student.model';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TeacherService } from '../teacher/teacher.service';
import { SafeHtml } from '@angular/platform-browser';
import { HomeService } from '../home/home.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserInfo } from '../model/user-info.model';

@Component({
  selector: 'connect-request',
  templateUrl: './connect-request.component.html',
  styleUrls: ['./connect-request.component.scss'],
})
export class ConnectRequestComponent implements OnInit {

  language: string;
  textDir: string;
  private destroy$ = new Subject<void>();

  safeAvatarSVG: SafeHtml;
  teacherInfo: UserInfo;
  isRequestView: boolean = false;

  constructor(
      private router: Router,
      private translate: TranslateService,
      private teacherService: TeacherService,
      private snackBar: MatSnackBar,
      private homeService: HomeService
    ) {
    this.language = translate.currentLang;
    translate.onLangChange.pipe(takeUntil(this.destroy$))
        .subscribe(({ lang }) => {
          this.language = lang
          if (this.language === 'ar'){
            this.textDir = 'rtl';
          }
          else {
            this.textDir = 'ltr';
          }
        });
  }
  
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    let studentInfo = JSON.parse(localStorage.getItem("avatarUser"));
    if (studentInfo.status == "READY_TO_CONNECT"){
      this.teacherService.getTeacherById(studentInfo.teacherId).subscribe((teacherUserInfo: UserInfo) => {
        console.log(teacherUserInfo);
        this.safeAvatarSVG = this.homeService.getAvatarImage();
        this.teacherInfo = teacherUserInfo;
        this.displayRequest();
      });
    }
  }

  displayRequest(){
      this.isRequestView = true;
  }

  acceptedConnectRequest(){
    let studentInfo = JSON.parse(localStorage.getItem("avatarUser"));
    studentInfo.status = "CONNECTED";
    this.updateStudentInfo(studentInfo);
    localStorage.setItem("avatarUser",JSON.stringify(studentInfo));
  }

  rejectedConnectRequest(){
    let studentInfo = JSON.parse(localStorage.getItem("avatarUser"));
    studentInfo.status = "PENDING";
    studentInfo.teacherId = "0";
    this.updateStudentInfo(studentInfo);
    localStorage.setItem("avatarUser",JSON.stringify(studentInfo));
  }


  updateStudentInfo(studentInfo: Student){
    this.teacherService.updateStudentInfo(studentInfo)
    .subscribe((response: Student)=> {
      if (response.status == "CONNECTED") {
        this.snackBar.open("Your are successfully connected with teacher", "", {duration: 2000});
        this.router.navigate([`/profile`]);
      }else {
        this.snackBar.open("Your are not connected with teacher", "", {duration: 2000});
        this.router.navigate([`/home`]);
      }
      // needs to redirect profile page
    }); 
  }
}
